import { useMemo } from 'react';
import { useQueryIntegrations } from './useQueryIntegrations.js';

const useQueryIntegration = (variables, options) => {
  const { integrations, data, ...rest } = useQueryIntegrations(options);
  const integration = useMemo(() => {
    if (data === void 0) {
      return void 0;
    }
    if ("externalId" in variables) {
      return integrations.find((integration2) => integration2.externalId === variables.externalId);
    }
    if ("integrationId" in variables) {
      return integrations.find((integration2) => integration2.id === variables.integrationId);
    }
    if ("rootId" in variables) {
      return integrations.find((integration2) => !!integration2.mirrorRegistries.find((m) => m.rootId === variables.rootId));
    }
    return null;
  }, [
    integrations,
    variables,
    data
  ]);
  return {
    integration,
    data,
    ...rest
  };
};

export { useQueryIntegration };
//# sourceMappingURL=useQueryIntegration.js.map
